import React from 'react'
import Header from '../Components/Header/header'
import Breadcrumb from '../Components/BreadCrumb/breadcrumb'
import BookConsultationForm from '../Components/BookaCall/bookacall'
import Footer from '../Components/Footer/footer'

const Bookingpage = () => {
  return (
    <div>
      <Header/>
      <Breadcrumb/>
      <BookConsultationForm/>
      <Footer/>
    </div>
  )
}

export default Bookingpage;